"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
//tslint:disable-next-line
var Symbol = require('es6-symbol');
function traverseGet(ctx) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return args.reduce(function (cur, key) { return cur ? cur[key] : undefined; }, ctx);
}
function traverseSet(ctx, val) {
    var args = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        args[_i - 2] = arguments[_i];
    }
    var length = args.length;
    var last = args[length - 1];
    var ancestors = args.slice(0, -1);
    var parent = ancestors.reduce(function (cur, key) {
        if (!cur[key]) {
            cur[key] = {};
        }
        return cur[key];
    }, ctx);
    parent[last] = val;
}
var endMarker = Symbol('memoize-end-marker');
function memoize(memory, func) {
    var marker = Symbol();
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = traverseGet.call.apply(traverseGet, __spread([null, memory, marker], args, [endMarker]));
        if (prev !== undefined) {
            return prev;
        }
        var result = func.call.apply(func, __spread([null], args));
        traverseSet.call.apply(traverseSet, __spread([null, memory, result, marker], args, [endMarker]));
        return result;
    };
}
exports.memoize = memoize;
//# sourceMappingURL=memoize.js.map